import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Container, Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Image } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import iicon from "../../assets/i.svg";
import Loader from "../Loader/Loader";

// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditor from "react-froala-wysiwyg";
import { RegEx } from "../../Utils/RegEx";
import swal from "sweetalert";
import axios from "axios";
import { GetTermsApi } from "./../API/MarketPlaceSetUp/TermsConditionsGet";
import { getToken } from "../../Utils/LocalStorage";
import { FroalaTextEditor } from "../FroalaEditor/FroalaTextEditor";

export const TermsConditions = () => {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const [PageUrl, setPageUrl] = useState("");
  const [GPageUrl, setGPageUrl] = useState("");
  const [PageUrlErr, setPageUrlErr] = useState("");
  const [PageContent, setPageContent] = useState("");
  const [PageContentErr, setPageContentErr] = useState("");
  // editor

  const [modelValue, setmodelValue] = useState("");

  const [isResponse, setisResponse] = useState([]);
  const [policyId, setpolicyId] = useState("");
  const [tcId, setTCId] = useState("");
  const [showEditButtonUrl, setshowEditButtonUrl] = useState(false);
  const [showEditButtonContent, setshowEditButtonContent] = useState(false);
  const [disableUrl, setDisableUrl] = useState(false);
  const [is_description, setIs_description] = useState("");

  const navigate = useNavigate();

  const Auth_Token = getToken();

  useEffect(() => {
    getTermsInfo();
  }, []);

  // editor

  const getTermsInfo = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    setLoading(true);
    const Response = await GetTermsApi(data, () => {
      navigate("/");
    });
    if (Response === false) {
      setLoading(false);
      swal({
        // title: "Error!",
        title: `Internal Server Error!`,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      setLoading(false);
      setisResponse(Response.data);
      setIs_description(Response.data[0].is_description);
      if (Response.data[0].is_description == 0) {
        setPageUrl(Response.data[0].content);
        setGPageUrl(Response.data[0].content);
        setmodelValue("");
        setshowEditButtonUrl(true);
        setDisableUrl(true);
        setshowEditButtonContent(false);
        setTCId(Response.data[0].t_c_id);
      } else if (Response.data[0].is_description == 1) {
        setDisableUrl(false);
        setshowEditButtonUrl(false);
        setPageUrl("");
        setmodelValue(Response.data[0].content);
        setshowEditButtonContent(true);
        setTCId(Response.data[0].t_c_id);
      } else {
        setDisableUrl(false);
        setshowEditButtonUrl(false);
        setPageUrl("");
        setmodelValue("");
        setshowEditButtonContent(true);
        setTCId(Response.data[0].t_c_id);
      }
      setpolicyId(Response.data[0].privacy_id);
    }
  };

  const handleEditURl = (e) => {
    e.preventDefault();
    setDisableUrl(false);
    setTimeout(() => {
      ref.current.focus();
    }, 500);
  };

  const handleEditContent = (e) => {
    e.preventDefault();
  };

  const handleModelChange = (model) => {
    // console.log(model,"model")
    setmodelValue(model);
    if (model.length != 0) {
      setDisableUrl(false);
      setshowEditButtonUrl(false);
      setPageUrl("");
      setIs_description(0);
      // setshowEditButtonContent(true)
    } else {
      setDisableUrl(true);
      setshowEditButtonUrl(true);
      setPageUrl(GPageUrl);
      setIs_description(1);
      // setshowEditButtonContent(false)
    }
  };

  useEffect(() => {
    if (modelValue.length != 0) {
      setDisableUrl(false);
      setshowEditButtonUrl(false);
      setPageUrl("");
      setIs_description(0);
      // setshowEditButtonContent(true)
    } else {
      setDisableUrl(true);
      setshowEditButtonUrl(true);
      setPageUrl(GPageUrl);
      setIs_description(1);
      // setshowEditButtonContent(false)
    }
  }, [modelValue]);

  const onChangeHandler = (fieldName, value) => {
    if (fieldName === "PageUrl") {
      setPageUrl(value);
      setmodelValue("");
      let re = RegEx.url;
      if (!re.test(value)) {
        setPageUrlErr("* Please Enter Valid Page Url");
      } else {
        setPageUrlErr("");
      }
    }
  };

  // const CancelHandler=()=>{
  //   setPageUrlErr("")
  //   setPageUrl("")
  // }
  // const CancelHandlerContent=()=>{
  //   setPageContent("")
  //   setPageContentErr("")
  // }

  // edit for Url
  const handleSubmit = (e) => {
    e.preventDefault();
    setPageContent("");
    setPageContentErr("");
    if (PageUrl.length === 0) {
      setPageUrlErr("* Please Enter Page Url");
    }
    if (PageUrl.length != 0) {
      setLoading(true);
      const cityId = localStorage.getItem("cityId");
      if (isResponse.length > 0) {
        axios({
          url: process.env.REACT_APP_COMMON_URL + "vms/mms/edittandc",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Token: Auth_Token,
          },
          data: {
            mms_city_id: parseInt(cityId),
            content: PageUrl,
            toggle: 0,
            t_c_id: tcId,
          },
        })
          .then((response) => {
            setLoading(false);
            // console.log(response.data.message);
            if (response.data.status == 429) {
              swal({
                // title: "Error!",
                title: `${response.data.message}`,
                icon: "error",
                buttons: "Ok",
                dangerMode: false,
              });
              setLoading(true);
            } else if (response.data.success == false) {
              swal({
                // title: "Error!",
                title: `${response.data.message}`,
                icon: "error",
                buttons: "Ok",
                dangerMode: false,
              });
              swal.stopLoading();
              swal.close();
              window.location.reload(false);
            } else {
              swal({
                // title: "Success!",
                title: `${response.data.message}`,
                icon: "success",
                buttons: "Ok",
                dangerMode: false,
              }).then(() => {
                swal.stopLoading();
                swal.close();
                window.location.reload(false);
              });
            }
          })
          .catch((err) => {
            if (err.response.data.message === "Token is invalid!") {
              setLoading(false);
              navigate("/");
            } else {
              setLoading(false);
              swal({
                // title: "Error!",
                title: `${err.data.message}`,
                icon: "error",
                buttons: "Ok",
                dangerMode: true,
              }).then(() => {
                swal.stopLoading();
                swal.close();
              });
            }
          });
      } else {
        axios({
          url: process.env.REACT_APP_COMMON_URL + "vms/mms/addtandc",
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Token: Auth_Token,
          },
          data: {
            mms_city_id: parseInt(cityId),
            content: PageUrl,
            toggle: 0,
          },
        })
          .then((response) => {
            setLoading(false);
            // console.log(response.data.message);
            if (response.data.status === 429) {
              swal({
                // title: "Error!",
                title: `${response.data.message}`,
                icon: "error",
                buttons: "Ok",
                dangerMode: false,
              });
              setLoading(true);
            } else if (response.data.success == false) {
              swal({
                // title: "Error!",
                title: `${response.data.message}`,
                icon: "error",
                buttons: "Ok",
                dangerMode: false,
              }).then(() => {
                swal.stopLoading();
                swal.close();
              });
            } else {
              swal({
                // title: "Success!",
                title: `${response.data.message}`,
                icon: "success",
                buttons: "Ok",
                dangerMode: false,
              }).then(() => {
                swal.stopLoading();
                swal.close();
                window.location.reload(false);
              });
            }
          })
          .catch((err) => {
            if (err.response.data.message === "Token is invalid!") {
              setLoading(false);
              navigate("/");
            } else {
              setLoading(false);
              swal({
                // title: "Error!",
                title: `${err.data.message}`,
                icon: "error",
                buttons: "Ok",
                dangerMode: true,
              }).then(() => {
                swal.stopLoading();
                swal.close();
                window.location.reload(false);
              });
            }
          });
      }
    }
  };

  // edit for Content
  const handleSubmitContent = (e) => {
    e.preventDefault();
    setPageUrlErr("");
    setPageUrl("");
    if (modelValue.length === 0) {
      setPageContentErr("*Please Enter Page Content");
    }
    if (modelValue.length != 0) {
      setLoading(true);
      const cityId = localStorage.getItem("cityId");
      // const regex = /(<([^>]+)>)/gi;
      // const newString = modelValue.replace(regex, "");
      axios({
        url:
          isResponse.length > 0
            ? process.env.REACT_APP_COMMON_URL + "vms/mms/edittandc"
            : process.env.REACT_APP_COMMON_URL + "vms/mms/addtandc",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Token: Auth_Token,
        },
        data: {
          mms_city_id: parseInt(cityId),
          content: modelValue,
          toggle: 1,
          t_c_id: tcId ?? "",
        },
      })
        .then((response) => {
          setLoading(false);
          if (response.data.status === 429) {
            swal({
              // title: "Error!",
              title: `${response.data.message}`,
              icon: "error",
              buttons: "Ok",
              dangerMode: false,
            });
            setLoading(true);
          } else {
            swal({
              // title: "Success!",
              title: `${response.data.message}`,
              icon: "success",
              buttons: "Ok",
              dangerMode: false,
            }).then(() => {
              swal.stopLoading();
              swal.close();
              setTimeout(() => {
                window.location.reload(false);
              }, 1000);
            });
          }
        })
        .catch((err) => {
          if (err.response.data.message === "Token is invalid!") {
            setLoading(false);
            navigate("/");
          } else {
            setLoading(false);
            swal({
              // title: "Error!",
              title: `${err.data.message}`,
              icon: "error",
              buttons: "Ok",
              dangerMode: true,
            }).then(() => {
              swal.stopLoading();
              swal.close();
              setTimeout(() => {
                window.location.reload(false);
              }, 1000);
            });
          }
        });
    }
  };

  // Image Upload froala

  // Handle image uploads
  const handleImageUpload = (e, editor, response) => {
    const imgSrc = response.link;

    // Insert the uploaded image into the editor
    editor.image.insert(imgSrc, false, null, editor.image.get(), null);

    // Update the editor content
    setPageContent(editor.html.get());
  };

  //

  return (
    <>
      {loading ? <Loader /> : ""}
      <p className="page-maintitle text-center">
        Link Your Existing Terms & Conditions Page Here
      </p>
      <Row>
        <Col md="2"></Col>
        <Col md="8">
          <Form
            // onSubmit={SaveHandler}
            className="formmain mx-2 mt-4 signin-row profile-form pb-4"
          >
            <Row>
              <Col md="12" className="">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <div className="d-flex justify-content-between p-2">
                    <Form.Label className="form-label-custom">
                      {["top"].map((placement) => (
                        <OverlayTrigger
                          // trigger={"click"}
                          key={placement}
                          placement={placement}
                          overlay={
                            <Tooltip
                              id={`tooltip-${placement}`}
                              className="Tooltips"
                              style={{ opacity: "1" }}
                            >
                              If you want to link to your existing terms &
                              conditions page from your own website. Here you
                              can provide the external link.
                            </Tooltip>
                          }
                        >
                          <Image
                            src={iicon}
                            className="mb-1"
                            width="15px"
                          ></Image>
                        </OverlayTrigger>
                      ))}
                      Page URL <span className="star-required">*</span>
                    </Form.Label>
                    {showEditButtonUrl == true ? (
                      <button
                        className="edit_button"
                        onClick={(e) => handleEditURl(e)}
                      >
                        {PageUrl.length == 0 ? "Add" : "Edit"}
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <InputGroup className="edit-border">
                    <Form.Control
                      ref={ref}
                      autoComplete="off"
                      type="text"
                      placeholder="Enter Page URL"
                      className="custom-formcontrol"
                      value={PageUrl}
                      disabled={disableUrl == true ? true : false}
                      onChange={(e) => {
                        onChangeHandler("PageUrl", e.target.value);
                      }}
                    />
                  </InputGroup>
                  {PageUrlErr && <p className="text-danger">{PageUrlErr}</p>}
                </Form.Group>
              </Col>
            </Row>
            <div className="text-center small-btns d-flex">
              {/* <Link 
                         onClick={CancelHandler}
                        >
                          <p className="view">Cancel</p>
                        </Link> */}
              {PageUrl.length != 0 ? (
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                  onClick={(e) => handleSubmit(e)}
                  style={{ width: 100 }}
                >
                  Save
                </Button>
              ) : (
                ""
              )}
            </div>
          </Form>
          <p class="loginwith-orange">
            <span>Or</span>
          </p>

          <Col md="12" className="mb-3 mx-2">
            <Form.Group className="mb-0" controlId="formBasicEmail">
              <div className="d-flex justify-content-between p-2">
                <Form.Label className="form-label-custom flex-content">
                  Page Content <span className="star-required">*</span>
                  <p className="info-text-space-f-13">
                    &#40;To start from a new line, please press Shift +
                    Enter.&#41;
                  </p>
                </Form.Label>
                {/* {showEditButtonContent == true ? <button className="edit_button" onClick={(e)=>handleEditContent(e)}>Edit</button> : ''} */}
                {/* <button className="edit_button">Edit</button> */}
              </div>
              <div className="p-3 page_cont">
                <FroalaTextEditor
                  TemplateContent={modelValue}
                  setTemplateContent={setmodelValue}
                />
              </div>
              {PageContentErr && (
                <p className="text-danger">{PageContentErr}</p>
              )}
            </Form.Group>
          </Col>
          <div className="text-center small-btns d-flex">
            {modelValue.length != 0 ? (
              <Button
                variant="primary"
                type="submit"
                className="green-btn mt-3"
                onClick={(e) => handleSubmitContent(e)}
                style={{ width: 100 }}
              >
                Save
              </Button>
            ) : (
              ""
            )}
          </div>
        </Col>
        <Col md="2"></Col>
      </Row>
    </>
  );
};
